export const drawerItemsMain = [
  {
    key: "CustomerOrderScreen",
    title: "Customer Order Screen",
    routes: [
      {
        nav: "CustomerOrderScreen",
        routeName: "CustomerOrderScreen",
        title: "Customer Order Screen",
      },
    ],
  },
  {
    key: "KanbanPOCScreen",
    title: "Kanban POC",
    routes: [
      {
        nav: "KanbanPOCScreen",
        routeName: "KanbanPOCScreen",
        title: "Kanban POC Report",
      },
    ],
  },
];
